import React, { useEffect } from "react";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";
import { Button } from "../assets/styles/ButtonStyle";
import { H3, Body2, Body3 } from "../assets/styles/Typography";
import { palette } from "../assets/styles/Palette";
import MoleculeHeader from "./Global/components/molecules/MoleculeHeader";
import {
  ContentsWrap,
  MainContent,
  TabContent5Item,
  TabContent5,
  PopupContent,
} from "../assets/styles/BusinessAnalysisStyle";

import { getUserMemberType } from "../utils/indexedDB";
import DeviceDetectionService from "../utils/DeviceDetectionService";

import { useAtom } from "jotai";
import { SELECTED_CUSTOMER_TYPE } from "./AtomStates";
import documentContentsImg from "../assets/images/document_contents.png";
import apiContentsImg from "../assets/images/api_contents.png";
import eduboardContentsImg from "../assets/images/eduboard_contents.png";
import outdoorLifeScreenImg from "../assets/images/outdoor_life_screen.png";

const PageAdmin = () => {
  const navigate = useNavigate();
  const [selectedCustomerType, setSelectedCustomerType] = useAtom(
    SELECTED_CUSTOMER_TYPE
  );

  // 관리자 기기 모드 선택 상태
  const [isAdmin, setIsAdmin] = React.useState(false);
  const [showDeviceSelector, setShowDeviceSelector] = React.useState(false);
  const [selectedDeviceType, setSelectedDeviceType] = React.useState(null);
  const [showServiceSelector, setShowServiceSelector] = React.useState(false);

  useEffect(() => {
    const checkMemberType = async () => {
      const accessToken = sessionStorage.getItem("accessToken");
      const userMemberType = await getUserMemberType(accessToken);

      console.log("🔍 사용자 멤버 타입 전체 정보:", userMemberType);
      console.log("🔍 member_type:", userMemberType?.member_type);
      console.log("🔍 is_admin:", userMemberType?.is_admin);

      // 관리자 체크 (member_type 99 기준)
      // is_admin 필드가 undefined인 경우를 고려하여 member_type만으로 판단
      if (userMemberType?.member_type === 99) {
        console.log("👨‍💼 관리자 사용자 감지 - 기기 모드 선택 UI 표시");
        console.log("조건 충족:", {
          member_type: userMemberType?.member_type,
          is_admin: userMemberType?.is_admin,
        });
        setIsAdmin(true);
        setShowDeviceSelector(true);
        return; // 리다이렉트하지 않고 UI 표시
      }

      // 기존 로직
      if (userMemberType.member_type === 11) {
        navigate("/DashBoard");
      } else if (userMemberType.member_type === 21) {
        navigate("/ApiDashBoard");
      } else if (userMemberType.member_type === 31) {
        navigate("/EducationDashBoard");
      } else if (
        userMemberType.member_type === 12 ||
        userMemberType.member_type === 22
      ) {
        navigate("/CustomerManage");
      } else if (userMemberType.member_type === 32) {
        navigate("/EduboardManage");
      }

      sessionStorage.removeItem("lastUrl");
    };

    checkMemberType();
  }, [navigate]);

  // 기기 모드 선택 핸들러
  const handleDeviceSelection = (deviceType) => {
    console.log(`🎯 관리자가 선택한 기기 타입: ${deviceType}`);

    let finalDeviceType = deviceType;

    // 자동 감지인 경우 실제 기기를 감지
    if (deviceType === "auto") {
      try {
        const detectedType = DeviceDetectionService.detectDevice();
        finalDeviceType = detectedType;
        console.log(`🔍 자동 감지 결과: ${detectedType}`);

        // 감지 결과 알림
        const deviceName =
          detectedType === "desktop"
            ? "데스크탑"
            : detectedType === "android"
            ? "안드로이드"
            : detectedType === "ios"
            ? "iOS"
            : "모바일";
        alert(`🔍 자동 감지 완료!\n감지된 기기: ${deviceName}`);
      } catch (error) {
        console.error("❌ 자동 감지 실패:", error);
        alert(
          "기기 자동 감지 중 오류가 발생했습니다. 데스크탑으로 설정합니다."
        );
        finalDeviceType = "desktop";
      }
    }

    // DeviceDetectionService를 사용해서 기기 타입 강제 설정
    try {
      const updatedType =
        DeviceDetectionService.updateDeviceType(finalDeviceType);
      console.log(`✅ 기기 타입 업데이트 완료: ${updatedType}`);
    } catch (error) {
      console.error("❌ 기기 타입 설정 실패:", error);
      alert("기기 모드 설정 중 오류가 발생했습니다.");
      return;
    }

    // 기기 타입 저장 및 서비스 선택 단계로 이동
    setSelectedDeviceType(finalDeviceType);
    setShowDeviceSelector(false);
    setShowServiceSelector(true);

    const displayName =
      finalDeviceType === "desktop"
        ? "데스크탑"
        : finalDeviceType === "android"
        ? "안드로이드"
        : finalDeviceType === "ios"
        ? "iOS"
        : "모바일";

    console.log(`📱 기기 모드 설정 완료: ${displayName}`);
  };

  // 서비스 타입 선택 핸들러
  const handleServiceSelection = (serviceType) => {
    console.log(
      `🎯 선택된 서비스: ${serviceType}, 기기 타입: ${selectedDeviceType}`
    );

    setSelectedCustomerType(serviceType);

    // 서비스 타입에 따라 적절한 페이지로 이동
    switch (serviceType) {
      case 1:
        navigate("/CustomerManage");
        break;
      case 2:
        navigate("/CustomerManage");
        break;
      case 3:
        navigate("/EduboardManage");
        break;
      default:
        navigate("/CustomerManage");
    }
  };

  return (
    <>
      <ContentsWrap>
        {/* <OrganismIncNavigation /> */}
        <MoleculeHeader />
        <MainContent Wide1030>
          <CenteredWrapper>
            <TitleArea>
              <H3
                color="gray900"
                style={{
                  fontSize: 28,
                  fontWeight: 700,
                  marginBottom: 12,
                  textAlign: "center",
                }}
              >
                {showDeviceSelector ? (
                  <>
                    👨‍💼 관리자 모드
                    <br />
                    기기 타입 선택
                  </>
                ) : showServiceSelector ? (
                  <>
                    🎯 서비스 선택
                    <br />
                    {selectedDeviceType === "desktop"
                      ? "🖥️ 데스크탑"
                      : selectedDeviceType === "android"
                      ? "📱 안드로이드"
                      : selectedDeviceType === "ios"
                      ? "📱 iOS"
                      : "📱 모바일"}{" "}
                    모드
                  </>
                ) : (
                  <>
                    AI 자동 생성
                    <br />
                    노코드 디스플레이 콘텐츠 솔루션
                  </>
                )}
              </H3>
              <Body2
                color="gray600"
                style={{ textAlign: "center", marginBottom: 40 }}
              >
                {showDeviceSelector
                  ? "테스트용 기기 타입을 선택해주세요. 선택한 타입에 따라 최적화된 컴포넌트가 로드됩니다."
                  : showServiceSelector
                  ? `${
                      selectedDeviceType === "desktop"
                        ? "데스크탑"
                        : selectedDeviceType === "android"
                        ? "안드로이드"
                        : selectedDeviceType === "ios"
                        ? "iOS"
                        : "모바일"
                    } 모드로 설정되었습니다. 이제 테스트할 서비스를 선택해주세요.`
                  : "AI가 디스플레이에 최적화된 콘텐츠를 자동생성합니다."}
              </Body2>
            </TitleArea>

            {/* 관리자 기기 선택 UI */}
            {showDeviceSelector ? (
              <DeviceSelectionRow>
                <DeviceCard>
                  <DeviceIcon>🖥️</DeviceIcon>
                  <DeviceTitle>데스크탑 모드</DeviceTitle>
                  <DeviceDesc>
                    데스크탑 환경에 최적화된 컴포넌트로 테스트합니다.
                    <br />
                    • 전체화면 모드 활성화
                    <br />
                    • 키보드 단축키 지원
                    <br />• 고해상도 디스플레이 최적화
                  </DeviceDesc>
                  <Button
                    Primary
                    Large
                    Fill
                    style={{ width: "100%", marginTop: 18 }}
                    onClick={() => handleDeviceSelection("desktop")}
                  >
                    데스크탑으로 테스트
                  </Button>
                </DeviceCard>

                <DeviceCard>
                  <DeviceIcon>📱</DeviceIcon>
                  <DeviceTitle>모바일/안드로이드 모드</DeviceTitle>
                  <DeviceDesc>
                    모바일 환경에 최적화된 컴포넌트로 테스트합니다.
                    <br />
                    • 터치 인터페이스 최적화
                    <br />
                    • 스크롤 기반 네비게이션
                    <br />• 안드로이드 스케일링 문제 해결
                  </DeviceDesc>
                  <Button
                    Primary
                    Large
                    Fill
                    style={{
                      width: "100%",
                      marginTop: 18,
                      backgroundColor: "#FF9800",
                    }}
                    onClick={() => handleDeviceSelection("android")}
                  >
                    모바일로 테스트
                  </Button>
                </DeviceCard>

                <DeviceCard>
                  <DeviceIcon>🔍</DeviceIcon>
                  <DeviceTitle>자동 감지 모드</DeviceTitle>
                  <DeviceDesc>
                    현재 브라우저와 기기를 자동으로 감지합니다.
                    <br />
                    • 실제 사용 환경 기반 감지
                    <br />
                    • 화면 크기 및 User Agent 분석
                    <br />• 최적화된 컴포넌트 자동 선택
                  </DeviceDesc>
                  <Button
                    Primary
                    Large
                    Fill
                    style={{
                      width: "100%",
                      marginTop: 18,
                      backgroundColor: "#4CAF50",
                    }}
                    onClick={() => handleDeviceSelection("auto")}
                  >
                    자동 감지로 테스트
                  </Button>
                </DeviceCard>
              </DeviceSelectionRow>
            ) : showServiceSelector ? (
              /* 서비스 선택 UI (기기 모드 선택 후) */
              <CardRow>
                <Card>
                  <CardImg>
                    <img
                      src={documentContentsImg}
                      alt="스마트 공공 '알림보드'"
                      style={{
                        width: "80px",
                        height: "60px",
                        objectFit: "contain",
                      }}
                    />
                  </CardImg>
                  <CardTitle>스마트 공공 '알림보드'</CardTitle>
                  <CardDesc>
                    공공기관의 보도자료, 정책, 행사 등의 문서를 업로드하는 즉시,
                    디지털 게시판에 최적화된 안내 콘텐츠로 자동으로 생성합니다.
                  </CardDesc>
                  <Button
                    Primary
                    Large
                    Fill
                    style={{ width: "100%", marginTop: 18 }}
                    onClick={() => {
                      showServiceSelector
                        ? handleServiceSelection(1)
                        : (() => {
                            setSelectedCustomerType(1);
                            navigate("/CustomerManage");
                          })();
                    }}
                  >
                    {showServiceSelector && selectedDeviceType
                      ? `${
                          selectedDeviceType === "desktop"
                            ? "🖥️"
                            : selectedDeviceType === "android"
                            ? "🤖"
                            : selectedDeviceType === "ios"
                            ? "🍎"
                            : "📱"
                        } 테스트 시작`
                      : "시작하기"}
                  </Button>
                </Card>
                <Card>
                  <CardImg>
                    <img
                      src={apiContentsImg}
                      alt="스마트 생산 '팩토리보드'"
                      style={{
                        width: "80px",
                        height: "60px",
                        objectFit: "contain",
                      }}
                    />
                  </CardImg>
                  <CardTitle>스마트 생산 '팩토리보드'</CardTitle>
                  <CardDesc>
                    생산 현장의 센서, MES, ERP, 공공 데이터를 실시간으로
                    연동하여, 안전·품질·생산성 현황을 한눈에 파악하는 맞춤형
                    모니터링 대시보드를 자동 생성합니다.
                  </CardDesc>
                  <Button
                    Primary
                    Large
                    Fill
                    style={{ width: "100%", marginTop: 18 }}
                    onClick={() => {
                      showServiceSelector
                        ? handleServiceSelection(2)
                        : (() => {
                            setSelectedCustomerType(2);
                            navigate("/CustomerManage");
                          })();
                    }}
                  >
                    {showServiceSelector && selectedDeviceType
                      ? `${
                          selectedDeviceType === "desktop"
                            ? "🖥️"
                            : selectedDeviceType === "android"
                            ? "🤖"
                            : selectedDeviceType === "ios"
                            ? "🍎"
                            : "📱"
                        } 테스트 시작`
                      : "시작하기"}
                  </Button>
                </Card>
                <Card>
                  <CardImg>
                    <img
                      src={outdoorLifeScreenImg}
                      alt="스마트 시티 '인포보드'"
                      style={{
                        width: "80px",
                        height: "60px",
                        objectFit: "contain",
                      }}
                    />
                  </CardImg>
                  <CardTitle>스마트 시티 '인포보드'</CardTitle>
                  <CardDesc>
                    날씨, 재난, 교통 정보 등 공공 API와 지역 소식을 자동으로
                    연동하여, 시민에게 유용한 최신 정보를 24시간 표출하는 스마트
                    안내판 콘텐츠를 자동 생성합니다.
                  </CardDesc>
                  <Button
                    Primary
                    Large
                    Fill
                    style={{ width: "100%", marginTop: 18 }}
                    onClick={() => {
                      showServiceSelector
                        ? handleServiceSelection(2)
                        : (() => {
                            setSelectedCustomerType(2);
                            navigate("/CustomerManage");
                          })();
                    }}
                  >
                    {showServiceSelector && selectedDeviceType
                      ? `${
                          selectedDeviceType === "desktop"
                            ? "🖥️"
                            : selectedDeviceType === "android"
                            ? "🤖"
                            : selectedDeviceType === "ios"
                            ? "🍎"
                            : "📱"
                        } 테스트 시작`
                      : "시작하기"}
                  </Button>
                </Card>
                <Card>
                  <CardImg>
                    <img
                      src={eduboardContentsImg}
                      alt="스마트 스쿨 '에듀보드'"
                      style={{
                        width: "80px",
                        height: "60px",
                        objectFit: "contain",
                      }}
                    />
                  </CardImg>
                  <CardTitle>스마트 스쿨 '에듀보드'</CardTitle>
                  <CardDesc>
                    학교 공지사항, 가정통신문, 식단표 등의 자료를 자동으로
                    분석하여, 교내 디지털 게시판에 최적화된 안내 콘텐츠로
                    자동으로 생성합니다.
                  </CardDesc>
                  <Button
                    Primary
                    Large
                    Fill
                    style={{ width: "100%", marginTop: 18 }}
                    onClick={() => {
                      showServiceSelector
                        ? handleServiceSelection(3)
                        : (() => {
                            setSelectedCustomerType(3);
                            navigate("/EduboardManage");
                          })();
                    }}
                  >
                    {showServiceSelector && selectedDeviceType
                      ? `${
                          selectedDeviceType === "desktop"
                            ? "🖥️"
                            : selectedDeviceType === "android"
                            ? "🤖"
                            : selectedDeviceType === "ios"
                            ? "🍎"
                            : "📱"
                        } 테스트 시작`
                      : "시작하기"}
                  </Button>
                </Card>
              </CardRow>
            ) : (
              /* 일반 사용자용 기본 서비스 카드들 (관리자가 아닌 경우) */
              <CardRow>
                <Card>
                  <CardImg>
                    <img
                      src={documentContentsImg}
                      alt="스마트 공공 '알림보드'"
                      style={{
                        width: "80px",
                        height: "60px",
                        objectFit: "contain",
                      }}
                    />
                  </CardImg>
                  <CardTitle>스마트 공공 '알림보드'</CardTitle>
                  <CardDesc>
                    공공기관의 보도자료, 정책, 행사 등의 문서를 업로드하는 즉시,
                    디지털 게시판에 최적화된 안내 콘텐츠로 자동으로 생성합니다.
                  </CardDesc>
                  <Button
                    Primary
                    Large
                    Fill
                    style={{ width: "100%", marginTop: 18 }}
                    onClick={() => {
                      setSelectedCustomerType(1);
                      navigate("/CustomerManage");
                    }}
                  >
                    시작하기
                  </Button>
                </Card>
                {/* 나머지 일반 사용자용 카드들은 생략 (필요시 추가) */}
              </CardRow>
            )}
          </CenteredWrapper>
        </MainContent>
      </ContentsWrap>
    </>
  );
};

export default PageAdmin;

const Bg = styled.div`
  min-height: 100vh;
  background: #fff;
`;

const TopBar = styled.div`
  width: 100%;
  height: 56px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 40px 0 24px;
  border-bottom: 1.5px solid #f2f3f7;
`;

const Logo = styled.div`
  font-size: 18px;
  font-weight: 700;
  color: #222;
`;

const TopMenu = styled.div`
  display: flex;
  gap: 24px;
`;

const MenuBtn = styled.button`
  background: none;
  border: none;
  color: #888;
  font-size: 15px;
  font-weight: 500;
  cursor: pointer;
  padding: 0;
  &:hover {
    color: #256ef4;
  }
`;

const MainSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: calc(100vh - 56px);
`;

const TitleArea = styled.div`
  margin-top: 60px;
  margin-bottom: 32px;
`;

const CardRow = styled.div`
  display: flex;
  gap: 32px;
  justify-content: center;
  margin-top: 12px;
`;

const Card = styled.div`
  width: 320px;
  min-height: 320px;
  background: #fff;
  border-radius: 18px;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.07);
  padding: 32px 28px 28px 28px;
  display: flex;
  flex-direction: column;
  align-items: center;
  opacity: ${(props) => (props.disabled ? 0.6 : 1)};
`;

const CardImg = styled.div`
  margin-bottom: 18px;
`;

const CardTitle = styled(Body3)`
  font-size: 18px;
  font-weight: 700;
  color: #256ef4;
  margin-bottom: 10px;
  text-align: center;
`;

const CardDesc = styled(Body2)`
  color: #464c53;
  font-size: 15px;
  text-align: center;
  margin-bottom: 8px;
  flex-grow: 1;
`;

const CenteredWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: calc(100vh - 100px);
  width: 100%;
`;

// 관리자 기기 선택 UI 스타일
const DeviceSelectionRow = styled.div`
  display: flex;
  gap: 24px;
  justify-content: center;
  margin-top: 20px;
  flex-wrap: wrap;
  max-width: 1200px;
  margin-left: auto;
  margin-right: auto;
`;

const DeviceCard = styled.div`
  width: 320px;
  min-height: 380px;
  background: #fff;
  border-radius: 20px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12);
  padding: 32px 24px 24px 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
  border: 2px solid transparent;
  transition: all 0.3s ease;
  flex: 1;
  max-width: 320px;

  &:hover {
    transform: translateY(-4px);
    box-shadow: 0 12px 40px rgba(0, 0, 0, 0.15);
    border-color: #256ef4;
  }

  @media (max-width: 1024px) {
    width: 280px;
    max-width: 280px;
  }
`;

const DeviceIcon = styled.div`
  font-size: 60px;
  margin-bottom: 24px;
  filter: drop-shadow(0 4px 8px rgba(0, 0, 0, 0.1));
`;

const DeviceTitle = styled(Body3)`
  font-size: 22px;
  font-weight: 700;
  color: #256ef4;
  margin-bottom: 16px;
  text-align: center;
`;

const DeviceDesc = styled(Body2)`
  color: #464c53;
  font-size: 16px;
  text-align: center;
  margin-bottom: 12px;
  flex-grow: 1;
  line-height: 1.6;
`;
